import * as Yup from 'yup'
import { OTP_INPUT_LENGTH } from './OtpInputForm.interface'

export const OtpInputFormSchema = Yup.object().shape({
  code: Yup.string()
    .required('Verification code is required.')
    .length(OTP_INPUT_LENGTH, 'Verification code is required.'),
})
